<template>
  <div class="h-full w-full relative">
    <EditorDeckSlidesEditorOverlay :show-top-bar="persistTopBar">
      <template #top-bar>
        <p class="flex items-center truncate max-w-md mb-0">
          URL:&nbsp;
          <InlineEditable
            :value="url as string"
            theme="dark"
            data-testid="url-editor-slide-input"
            @click="persistTopBar = true"
            @blur="persistTopBar = false"
            @clear="url = slide.content_url"
            @cancel="url = slide.content_url"
            @save="updateSlide"
            @input="url = $event"
          />
        </p>
      </template>

      <template #content>
        <DeckDynamicSlide :url="`${slide.content_url}`" />
      </template>
    </EditorDeckSlidesEditorOverlay>
  </div>
</template>

<script lang="ts" setup>
import type { PropType, DeepReadonly } from 'vue'
import { ref, watch } from 'vue'
import type { Slide } from '@/entities/deck'

const props = defineProps({
  slide: {
    type: Object as PropType<DeepReadonly<Slide>>,
    required: true,
  },
})

const emit = defineEmits(['notify', 'update:slide'])

const url = ref<string | null>(props.slide.content_url)
const persistTopBar = ref<boolean>(false)

watch(
  () => props.slide.content_url,
  contentUrl => {
    if (contentUrl) {
      url.value = contentUrl
    }
  },
  { immediate: true }
)

async function updateSlide() {
  if (!isValidUrl(url.value!)) {
    url.value = props.slide.content_url
    emit('notify', {
      title: 'Valid URLs must start with https:// or http://.',
      type: 'warning',
    })
    return
  }

  emit('update:slide', {
    id: props.slide.id,
    content_url: url.value,
  })
}

function isValidUrl(val: string) {
  try {
    const url = new URL(val)
    const isVrifyUrl = url.hostname.includes('vrify')
    const hasValidProto = url.protocol === 'http:' || url.protocol === 'https:'
    const notDecksPath = !new RegExp('/decks/').test(url.href)

    if (isVrifyUrl) {
      return hasValidProto && notDecksPath
    }

    return hasValidProto
  } catch (e) {
    return false
  }
}
</script>
